export enum StatisticTypeEnum {
    Revenue,
    CountOfChecks,
    AverageCheck,
    MobileApplication,
    GratitudeIndex,
    ComplaintIndex,
    NonConformityPointsGeneral,
    NonConformityPointsTechnicalCondition,
}
